var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVertGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 14,
    viewBox: "0 0 4 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16683 2.00016C3.16683 2.64069 2.64069 3.16683 2.00016 3.16683C1.35964 3.16683 0.833496 2.64069 0.833496 2.00016C0.833496 1.35964 1.35964 0.833496 2.00016 0.833496C2.64069 0.833496 3.16683 1.35964 3.16683 2.00016ZM0.833496 7.00016C0.833496 6.35964 1.35964 5.8335 2.00016 5.8335C2.64069 5.8335 3.16683 6.35964 3.16683 7.00016C3.16683 7.64069 2.64069 8.16683 2.00016 8.16683C1.35964 8.16683 0.833496 7.64069 0.833496 7.00016ZM0.833496 12.0002C0.833496 11.3596 1.35964 10.8335 2.00016 10.8335C2.64069 10.8335 3.16683 11.3596 3.16683 12.0002C3.16683 12.6407 2.64069 13.1668 2.00016 13.1668C1.35964 13.1668 0.833496 12.6407 0.833496 12.0002Z",
    fill: "#2B8C34",
    stroke: "#2B8C34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVertGreen);
export default __webpack_public_path__ + "static/media/vert_green.b353bd0cb32932394469beb19a15b8b0.svg";
export { ForwardRef as ReactComponent };